export const DICTIONARIES_IN_API = {
	ALL: "WL", // Look in all dictionaries
	BIG: "BIG", // World's Biggest Crossword
	BRAIN: "BRAIN", // Word Brain
	CHU: "CHU", // Word Chums
	CONNECT: "CONNECT", // Word Connect
	COOKIES: "COOKIES", // Word Cookies
	CROSS: "CROSS", // CodyCross
	CROSSY: "CROSSY", // Word Crossy
	CWF: "CWF", // Crossword with Friends
	DOM: "DOM", // Word Domination
	FEU: "FEU", // Wordfeud
	HQ: "HQ", // HQ
	JOURNEY: "JOURNEY", // Word Journey
	JUM: "JUM", // Just Jumble
	NYTC: "NYTC", // NY Times Crossword
	NYTS: "NYTS", // NY Times Spelling
	PICS: "PICS", // 4 Pics 1 Word
	PICTO: "PICTO", // Pictoword
	STORY: "STORY", // Words Story
	SWIPE: "SWIPE", // Word Swipe
	TRIP: "TRIP", // Word Trip
	TWIST: "TWIST", // Text Twist
	US: "US", // Scrabble US
	UK: "UK", // Scrabble UK
	WWF: "WWF", // Words With Friends
	YDR: "YDR", // YDR definition available
	ANAGRAM: "ANAGRAM", // YDR definition available
};

export const DICTIONARIES = {
	1: DICTIONARIES_IN_API.WWF,
	2: DICTIONARIES_IN_API.US,
	3: DICTIONARIES_IN_API.UK,
	4: DICTIONARIES_IN_API.ANAGRAM,
	5: DICTIONARIES_IN_API.PICS,
	6: DICTIONARIES_IN_API.JUM,
	7: DICTIONARIES_IN_API.CONNECT,
	8: DICTIONARIES_IN_API.COOKIES,
	9: DICTIONARIES_IN_API.CHU,
	10: DICTIONARIES_IN_API.TWIST,
	11: DICTIONARIES_IN_API.CROSS,
	12: DICTIONARIES_IN_API.FEU,
	13: DICTIONARIES_IN_API.BRAIN,
	14: DICTIONARIES_IN_API.STORY,
	15: DICTIONARIES_IN_API.SWIPE,
	16: DICTIONARIES_IN_API.ALL,
};
